import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class UTCommunicationListItem extends SearchModelBase {
  senderId: string = '';
  logType: string = '';
  title: string = '';
  recipient: string = '';
  recCompanyName: string = '';
  sType: string = '';
  faxNo: string = '';
  email: string = '';
  state: string = '';
  postDate: string | null = null;
  fromPostDate: string | null = null;
  toPostDate: string | null = null;
  //recCompanyId: number = 0;
  logFileId: number = 0;
  refNo: string = '';
  hblNo: string = '';
  tbName: string = '';
  tbId: number = 0;
  idex: number = 0;
  //detailId: number = 0;

  private static ExportCollection: XCol.XExportColumn[] = [
    XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
    XCol.Create({ col: 1, text: 'Log Type', width: 80, dataIndex: 'logType', noNullOrEmptySearch: true, defaultColumnFocus: true }),
    XCol.Create({ col: 2, text: 'Ref #', width: 100, dataIndex: 'refNo' }),
    XCol.Create({ col: 3, text: 'HBL #', width: 100, dataIndex: 'hblNo' }),
    XCol.Create({ col: 4, text: 'User Name', width: 80, dataIndex: 'senderId' }),
    XCol.Create({ col: 5, text: 'Title', width: 200, dataIndex: 'title' }),
    XCol.Create({ col: 6, text: 'Recipient', width: 300, dataIndex: 'recipient' }),
    XCol.Create({ col: 7, text: 'Company Name', width: 140, dataIndex: 'recCompanyName' }),
    XCol.Create({ col: 8, text: 'Type', width: 50, dataIndex: 'sType' }),
    XCol.Create({ col: 9, text: 'Email Address', width: 140, dataIndex: 'email' }),
    XCol.Create({ col: 10, text: 'Status', width: 80, dataIndex: 'state' }),
    XCol.Create({ col: 11, text: 'Date', width: 120, dataIndex: 'postDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center }),
    XCol.Create({ col: 12, text: 'Fax #', width: 140, dataIndex: 'faxNo' }),
  ];

  public static getExportCollection(): XCol.XExportColumn[] {
    return this.ExportCollection;
  };

  public static OrderBy = { orderBy: UTCommunicationListItem.prototype.postDate, orderByAscending: false };

  public static formatData(data: UTCommunicationListItem[]) {
    return data.map((d: UTCommunicationListItem, index: number) => ({
      ...d,
      id: index + 1 //for cell focus
    }));
  }
  public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
    postDate: { from: 'fromPostDate', to: 'toPostDate' },
  }
}
